
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetojyotilinga() {



  const cardData =
  {
    keyword: ' Pune to 5 Jyotirlinga Darshan Bus Hire',
    heading: 'Vaishnavi Travels: Pune to 5 Jyotirlinga Darshan Bus Hire',
    headingDescription: 'Vaishnavi Travels offers dependable and affordable Pune to 5 Jyotirlinga Darshan Bus Hire, specially designed for pilgrims and groups seeking a spiritual journey. Our buses are spacious, well-maintained, and equipped with comfortable seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable travel experience. With professional drivers, timely service, and flexible booking options, we make your pilgrimage stress-free and convenient. Whether traveling with family, friends, or religious groups, Vaishnavi Travels guarantees safe, reliable, and comfortable bus rental services from Pune to the sacred 5 Jyotirlinga temples, allowing you to focus on devotion while we take care of the journey.',

    top: 'Top Places to Visit in maharashtra 5 Jyotirlinga with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga",
    "description": "Bhimashankar, located in the Sahyadri ranges about 110 km from Pune, is one of the 12 Jyotirlingas of Lord Shiva. Surrounded by dense forests, it is also a wildlife sanctuary home to the giant Indian squirrel. The temple’s Nagara-style architecture and serene environment attract both devotees and trekkers. Pilgrims believe that worshipping here removes obstacles and grants divine blessings. Monsoon adds mist, waterfalls, and scenic trails, making it a beautiful pilgrimage trek. Bhimashankar is Maharashtra’s divine blend of spirituality and nature."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Trimbakeshwar, near Nashik, is one of the most sacred Jyotirlingas dedicated to Lord Shiva. The temple is unique as it houses three lingams symbolizing Brahma, Vishnu, and Mahesh. Built in black stone with Nagara-style architecture, it is surrounded by the Brahmagiri Hills where the Godavari River originates. Pilgrims come here for rituals like Narayan Nagbali and Shraddha ceremonies. The spiritual aura is enhanced by the flowing Godavari nearby. Trimbakeshwar is Maharashtra’s eternal center of faith and rituals."
  },
  {
    "title": "Grishneshwar Jyotirlinga",
    "description": "Grishneshwar Temple, located near Ellora Caves in Aurangabad, is one of the 12 Jyotirlingas and the last in the list. Rebuilt in the 18th century by Ahilyabai Holkar, it is an exquisite example of red-stone temple architecture. The temple walls are adorned with carvings of gods, goddesses, and mythological scenes. Devotees believe that a visit here grants moksha and spiritual peace. Its proximity to the Ellora caves makes it an ideal spiritual and heritage trip. Grishneshwar is Maharashtra’s sacred shrine of devotion and art."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga",
    "description": "Aundha Nagnath Temple in Hingoli district is one of the oldest Jyotirlingas, believed to have been built during the Yadava dynasty. The temple is associated with the Pandavas and is said to have been visited by Bhima himself. Its Hemadpanthi-style architecture, stone carvings, and massive pillars fascinate devotees. The temple is a center for Shaiva devotion and attracts pilgrims year-round. Rituals and festivals are celebrated here with great enthusiasm. Aundha Nagnath is Maharashtra’s ancient spiritual landmark of Lord Shiva."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga",
    "description": "Parli Vaijnath, located in Beed district, is a revered Jyotirlinga believed to grant relief from ailments and diseases. The temple is built on a hill and offers panoramic views of the surrounding landscape. Its Hemadpanthi-style architecture with intricate stone carvings reflects medieval grandeur. Devotees believe worship here brings health, peace, and prosperity. Festivals like Mahashivratri and Shravan attract large crowds of pilgrims. Parli Vaijnath is Maharashtra’s divine abode of healing and blessings."
  }
],

"services": [
  {
    "name": "5 Jyotirlinga Tour Bus from Pune",
    "description": "Embark on a sacred journey with our 5 Jyotirlinga tour bus service from Pune, tailored for spiritual seekers and devotees. This multi-day pilgrimage covers major Jyotirlinga temples across Maharashtra including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Our buses are equipped with comfortable seating, ample storage, and experienced drivers familiar with religious routes. Enjoy devotional music on board, stopovers at local eateries, and guided support if required. Ideal for religious groups, senior citizens, and families looking to explore spiritual India with peace and safety."
  },
  {
    "name": "AC Pilgrimage Bus Hire Pune",
    "description": "Premium AC bus rental service in Pune for pilgrimage tours such as Jyotirlinga Yatra, Shaktipeeth Darshan, or temple circuits across Maharashtra and beyond. Our AC buses ensure a relaxed journey with reclining seats, ambient lighting, clean interiors, and overhead storage. Ideal for long-distance spiritual travel, each bus is maintained to high hygiene standards and comes with devotional audio options. Drivers are trained for night halts and temple route management."
  },
  {
    "name": "Jyotirlinga Darshan Bus Package Pune",
    "description": "Complete Jyotirlinga Darshan bus package from Pune covering 5 sacred temples with itinerary planning, hotel coordination, and full transportation. Buses include AC/Non-AC options, onboard water, and storage for pilgrimage essentials. Special arrangements for senior citizens and large groups including group seating, onboard care kits, and optional priest-led guidance at major stops. Book as a complete tour package for stress-free travel."
  },
  {
    "name": "Group Tour Bus for Jyotirlinga Yatra",
    "description": "Organized group tour buses for Jyotirlinga Yatra starting from Pune. Suitable for societies, religious trusts, spiritual organizations, and senior citizen groups. Includes multiple pickup points, overnight travel options, halt coordination, and route assistance. Our fleet of 32, 40, and 50 seater buses caters to small and large pilgrim groups. Clean restrooms at halts, onboard music, and prayer-friendly environment are included in every trip."
  },
  {
    "name": "Spiritual Trip Bus Pune",
    "description": "Bus hire service in Pune designed for spiritual trips such as Jyotirlinga, Shaktipeeth, Ashtavinayak, and temple circuits across Maharashtra. Our buses offer comfortable seating, adjustable lighting, route maps, and guidance to religious hotspots. Customizable trip durations, flexible halts, and courteous drivers ensure a peaceful experience. Perfect for elderly travelers, family pilgrims, and local temple groups planning multi-day Yatras."
  },
  {
    "name": "50 Seater Jyotirlinga Bus Rental",
    "description": "Spacious 50 seater bus rental ideal for large groups undertaking Jyotirlinga pilgrimages from Pune. Buses are equipped with wide aisles, cushioned seats, full ventilation or AC, and ample luggage capacity. Great for temple associations, schools, or mass community trips. Our team helps with planning halts, food breaks, and hotel arrangements along the religious route."
  },
  {
    "name": "Non AC Jyotirlinga Trip Bus Pune",
    "description": "Budget-friendly Non-AC buses for Jyotirlinga Darshan from Pune, ideal for short or long temple trips. These buses are perfect for groups seeking economical options without compromising on reliability and comfort. Includes basic seating, open ventilation, and essential storage. Routes covered include all 5 major Jyotirlingas with temple-wise halts and early morning temple entry planning."
  },
  {
    "name": "Bus for Religious Group Pune",
    "description": "Specialized bus rental for religious groups and spiritual travelers in Pune. Buses available in AC and Non-AC variants with seating capacities ranging from 25 to 50 seats. Our service is designed for smooth coordination of multiple stops, safe travel at night, and assistance for elderly or special-needs pilgrims. We also offer route planning and driver rotation for long-distance temple tours."
  },
  {
    "name": "Pune to 5 Temple Tour Bus",
    "description": "Plan a devotional 5-temple tour from Pune with our reliable bus services. Whether visiting Bhimashankar, Trimbakeshwar, Grishneshwar, or other major shrines, we offer full support for scheduling, rest breaks, and early temple visits. Clean and devotional atmosphere onboard, with trained drivers who know pilgrimage routes. Buses can be customized with spiritual decor upon request."
  },
  {
    "name": "Family Trip Jyotirlinga Bus Hire",
    "description": "Private bus hire for families planning Jyotirlinga pilgrimages from Pune. Ensures your entire group stays together with personalized pickup points, stop preferences, and custom meal breaks. Family-friendly drivers, entertainment options, and onboard storage for snacks, prasad, and luggage. Makes religious tours meaningful and comfortable for every generation in your household."
  },
  {
    "name": "Outstation Jyotirlinga Bus Pune",
    "description": "Outstation bus rental from Pune for multi-day Jyotirlinga Yatras covering distances across Maharashtra and neighboring states. Buses are maintained for long journeys, with periodic rest stops, dual driver setup for night travel, and optional onboard sleeping arrangements. Includes tolls, permits, and priority scheduling for major pilgrimage weekends or festival days."
  },
  {
    "name": "Luxury Religious Tour Bus Pune",
    "description": "Travel in style and comfort for your next religious journey with our luxury buses for Jyotirlinga and temple circuits. Features include push-back seats, curtains, WiFi, onboard charging, bottled water, and premium upholstery. Recommended for NRIs, senior citizen groups, or private religious gatherings looking for a comfortable experience without hassle. Available for Pune departures year-round."
  },
  {
    "name": "Book 5 Jyotirlinga Bus Online",
    "description": "Book your 5 Jyotirlinga bus tour online from Pune with ease using our fast and secure platform. View available dates, seating options, package inclusions, and pricing before confirming. Get instant confirmation, route support, and payment receipts. Modify trip dates or group size easily. Ideal for temple trusts, community groups, and families preferring a digital-first booking experience."
  }
],
"tableData": [
  ["5 Jyotirlinga Tour Bus from Pune", "AC Pilgrimage Bus Hire Pune"],
  ["Jyotirlinga Darshan Bus Package Pune", "Group Tour Bus for Jyotirlinga Yatra"],
  ["Spiritual Trip Bus Pune", "50 Seater Jyotirlinga Bus Rental"],
  ["Non AC Jyotirlinga Trip Bus Pune", "Bus for Religious Group Pune"],
  ["Pune to 5 Temple Tour Bus", "Family Trip Jyotirlinga Bus Hire"],
  ["Outstation Jyotirlinga Bus Pune", "Luxury Religious Tour Bus Pune"],
  ["Book 5 Jyotirlinga Bus Online"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to 5 Jyotirlinga Darshan Bus Hire",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and spiritual journey solutions with bus hire services from Pune to the 5 Jyotirlinga pilgrimage sites across Maharashtra."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Pilgrimage Buses",
    "WhyChoosedescription": "Our buses offer cushioned seating, clean interiors, and ample space to ensure a peaceful and comfortable darshan experience for all devotees."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We maintain high safety and hygiene standards by regularly servicing and sanitizing each vehicle before every trip."
  },
  {
    "WhyChooseheading": "Customizable Packages for Multi-Day Darshan Yatras",
    "WhyChoosedescription": "Choose from flexible multi-day rental options designed specifically for Jyotirlinga yatra schedules, including overnight halts."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Knowledge",
    "WhyChoosedescription": "Our drivers are experienced, courteous, and well-versed with all routes covering the 5 Jyotirlingas, ensuring a smooth journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "All charges including fuel, tolls, driver allowances, and taxes are included—ensuring peace of mind and no last-minute surprises."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimage Groups and Religious Tours",
    "WhyChoosedescription": "Ideal for spiritual tour organizers, family groups, and temple trusts looking to arrange Jyotirlinga darshan from Pune."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist you with itinerary planning, booking, and real-time travel support."
  }
]



























  }







const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus hire services for Pune to 5 Jyotirlinga Darshan?',
      answer: 'Yes, Vaishnavi Travels provides comprehensive bus hire services from Pune for the 5 Jyotirlinga Darshan tour, perfect for religious groups and spiritual journeys.',
    },
    {
      question: 'What types of buses are available for the 5 Jyotirlinga Darshan trip?',
      answer: 'We offer various options including 32 seater tempo travellers and 40 to 50 seater coaches, available in both AC and non-AC variants to suit different group sizes and comfort preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus for the 5 Jyotirlinga Darshan from Pune?',
      answer: 'Costs vary based on bus type and duration but generally start around ₹15,000 for multi-day tours. We provide customized quotes based on your itinerary and group size.',
    },
    {
      question: 'Are experienced drivers included in the bus hire service?',
      answer: 'Yes, all bus hires come with professional, licensed drivers who are familiar with the routes to the Jyotirlinga temples, ensuring safety and smooth travel.',
    },
    {
      question: 'Can the itinerary be customized for the Jyotirlinga Darshan tour?',
      answer: 'Absolutely. We work with you to customize the route, stops, and schedule according to your group’s preferences and timing.',
    },
    {
      question: 'How far in advance should I book the bus for this pilgrimage?',
      answer: 'It is advisable to book at least 1-2 weeks in advance, especially during peak pilgrimage seasons, to secure availability and best pricing.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are usually additional and will be transparently included in your final quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sanjay Patil",
    position: "Pilgrimage Group Leader",
    feedback:
      "Vaishnavi Travels made our 5 Jyotirlinga Darshan journey comfortable and hassle-free. The bus was spacious, clean, and the driver was very professional. Highly recommend their services for religious tours.",
    rating: 5,
  },
  {
    name: "Mrs. Neeta Kulkarni",
    position: "Spiritual Group Organizer",
    feedback:
      "We booked a 50 seater AC coach for our pilgrimage to the Jyotirlingas. The service was excellent, the bus well-maintained, and the driver courteous and knowledgeable about the routes. A wonderful experience overall.",
    rating: 5,
    style: "style-2",
  }
];


























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 5 Jyotirlinga Darshan Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-5-jyotirlinga-bus.jpg",
  "description": "Book Pune to 5 Jyotirlinga Darshan bus hire with Vaishnavi Travels for AC and Non AC buses perfect for spiritual pilgrimages, group tours, and religious trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "750"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-5-jyotirlinga-darshan-bus-hire"
  }
};



  return (
    <div>



<Helmet>
  <title>Pune to 5 Jyotirlinga Darshan Bus Hire | Spiritual Pilgrimage Bus | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to 5 Jyotirlinga Darshan bus hire with Vaishnavi Travels for AC and Non AC buses perfect for spiritual pilgrimages, group tours, and religious trips."
  />
  <meta
    name="keywords"
    content="5 Jyotirlinga Tour Bus from Pune, AC Pilgrimage Bus Hire Pune, Jyotirlinga Darshan Bus Package Pune, Group Tour Bus for Jyotirlinga Yatra, Spiritual Trip Bus Pune, 50 Seater Jyotirlinga Bus Rental, Non AC Jyotirlinga Trip Bus Pune, Bus for Religious Group Pune, Pune to 5 Temple Tour Bus, Family Trip Jyotirlinga Bus Hire, Outstation Jyotirlinga Bus Pune, Luxury Religious Tour Bus Pune, Book 5 Jyotirlinga Bus Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojyotilinga;